module.exports = __webpack_public_path__ + "img/react.cff40704.png";